import { createContext, useContext, useEffect, type ReactNode } from 'react';
import useToggle from '@unifyapps/hooks/useToggle';

const PrintContext = createContext<boolean>(false);

interface PrintProviderProps {
  children: ReactNode;
}

export function PrintProvider({ children }: PrintProviderProps) {
  const [isPrinting, { on, off }] = useToggle(false);

  useEffect(() => {
    window.addEventListener('beforeprint', on);
    window.addEventListener('afterprint', off);

    return () => {
      window.removeEventListener('beforeprint', on);
      window.removeEventListener('afterprint', off);
    };
  }, [off, on]);

  return <PrintContext.Provider value={isPrinting}>{children}</PrintContext.Provider>;
}

export function usePrint(): boolean {
  return useContext(PrintContext);
}
